/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  PLATFORM_ID,
  Inject,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductControlSandbox } from '../../../../core/product-control/product-control.sandbox';
import { Router } from '@angular/router';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { Subscription } from 'rxjs';
import { WishlistSandbox } from '../../../../core/wishlist/wishlist.sandbox';
import { CartSandbox } from '../../../../core/cart/cart.sandbox';
import { CartPopupComponent } from '../cart/modal/cart-popup/cart-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss']
})

export class ControlsComponent implements OnInit, OnDestroy, OnChanges {


  @Input() product: any;
  @Input() show: any;
  @Input() type: string;
  @Input() page: string;
  @Input() cartOptionValueArray: any;
  @Input() selectedOptions: any;
  public optionValueArray: any = [];
  public optionNameSelected: any;
  public totalPrice = 0;
  @Output() OpenProductDialog: EventEmitter<any> = new EventEmitter();
  @Output() emptyDecorator: EventEmitter<any> = new EventEmitter();
  @Output() QuantityChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectCompare: EventEmitter<any> = new EventEmitter<any>();
  @Output() closePopup: EventEmitter<any> = new EventEmitter<any>();
  @Output() setPincodeFocus: EventEmitter<any> = new EventEmitter<any>();
  public count = 1;
  public align = 'center center';
  public quantity: any = 1;
  public isWish: any = {};
  public isAdd = [];
  public products: any;
  public currentUser: any;
  public tirePrice: any;
  private subscriptions: Array<Subscription> = [];
  public pincodeFocus = false;
  public tireQuantityArray: any = [];
  @Input() taxValue: any;
  @Input() taxType: any;
  @Input() productPrice: any;

  constructor(
    public snackBar: MatSnackBar,
    public wishlistSandbox: WishlistSandbox,
    public controlSandbox: ProductControlSandbox,
    public listSandbox: ListsSandbox,
    private router: Router,
    public cd: ChangeDetectorRef,
    public cartBaseSandbox: CartSandbox,
    public dialog: MatDialog,

    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.currentUser = JSON.parse(localStorage.getItem('storeUser'));
    }

    if (this.product) {
      if (this.product.wishListStatus && this.product.wishListStatus === 1) {
        this.isWish[this.product] = 'warn';
      }
      if (this.product.cartCount > 0) {
        this.count = this.product.cartCount;
      }
    }
    this.layoutAlign();
  }




  ngOnChanges(changes: SimpleChanges): void {
    if (this.product.wishListStatus === 1) {
      this.isWish[this.product] = 'warn';
    } else {
      this.isWish[this.product] = '';
    }
  }



  public layoutAlign() {
    if (this.type === 'all') {
      this.align = 'space-between center';
    } else if (this.type === 'wish') {
      this.align = 'start center';
    } else if (this.type === 'detail') {
      this.align = 'start center';
    } else if (this.type === 'home') {
      this.align = 'start center';
    } else {
      this.align = 'center center';
    }
  }

  public changeCount(operation) {
    const product: any = {};
    if (operation === 'remove' && this.quantity > 1) {
      this.quantity -= 1;
    } else if (operation === 'add') {
      this.quantity += 1;
    }
  }


  public addToWishList(product) {

    if (product.wishListStatus === 1) {
      this.isWish[product] = '';
      const params: any = {};
      params.wishlistProductId = product.productId;
      const param: any = {};
      param.page = this.page;
      param.details = product;
      param.checked = false;
      this.listSandbox.changeWishlistStatus(param);
      this.wishlistSandbox.deleteWishlist(params);
      this.getWishList();
    } else {
      this.isWish[product] = 'warn';
      this.isAdd = [];
      this.isAdd[product.productId] = true;
      let currentUser: any;
      if (isPlatformBrowser(this.platformId)) {
        currentUser = JSON.parse(localStorage.getItem('storeUser'));
      }
      if (currentUser) {
        const params: any = {};
        params.productId = product.productId;
        params.productOptionValueId = '';
        const param: any = {};
        param.page = this.page;
        param.details = product;
        param.checked = true;
        this.listSandbox.changeWishlistStatus(param);
        this.controlSandbox.addToWishlist(params);
        this.getWishList();
      } else {
        if (this.type === 'popup') {
          this.closePopup.emit('close');
        }
        this.router.navigate(['/auth']);
      }
    }

    this.cd.detectChanges();
  }


  getWishList() {
    const params: any = {};
    params.limit = 10;
    params.offset = '';
    this.wishlistSandbox.getWishlist(params);
  }

  // add product to cart
  // public addToCart(product) {
  //   if (this.type === 'popup') {
  //     this.closePopup.emit('close');
  //   }
  //   this.router.navigate(['/products/productdetails/', product.productSlug]);
  // }
  // addToCart(product, operation) {
  //   console.log('abc');
  // 	if (this.currentUser) {
  //     console.log( product);
  // 		const params: any = {};
  // 		params.productId = product.productId;
  // 		params.productPrice = product.price;
  // 		params.tirePrice = this.tirePrice;
  // 		params.varientName = product.variantName;
  // 		params.productVarientOptionId = product.variantId;
  // 		params.skuName = product.sku;
  // 		if (operation) {
  // 			params.quantity = Number(product.productCount) + 1;
  // 		}
  // 		if (!operation) {
  // 			params.quantity = Number(product.productCount) - 1;
  // 		}
  // 		if (product.productOption && product.productOption.length > 0) {
  // 			const tempParams: any = {};
  // 			tempParams.totalOptions = product._totalOptions;
  // 			tempParams.options = product.productOption;
  // 			tempParams.optionValueArray = product._optionValueArray;
  // 			params.optionName = JSON.stringify(tempParams);
  // 			params.optionValueName = '';
  // 		}
  // 		params.productOptionValueId = product.selectedOptions;
  // 		this.cartBaseSandbox.doAddToCart(params);
  // 	}
  // }

  public addToCart(details, status: boolean = false) {

    console.log(" ********* add to cart fired ********** ", details);

    if (this.product.pincodeBasedDelivery === 1) {
      if (this.show) {
        if (this.product.stockStatusId !== 2 && (this.product.quantity)) {
          this.addToCartMethod(details, status);
        } else {
          return;
        }
      } else {
        this.pincodeFocus = true;

        this.setPincodeFocus.emit(this.pincodeFocus);
      }
    } else {
      if (this.product.stockStatusId !== 2 && (this.product.quantity)) {
        this.addToCartMethod(details, status);
      } else {
        return;
      }
    }
  }


  addToCartMethod(details, status) {
    const product = JSON.parse(JSON.stringify(details));

    if (product.quantity == 0) {
      this.snackBar.open('Product is out of stock', '×', {
        panelClass: 'error',
        verticalPosition: 'top',
        horizontalPosition: 'right',
        duration: 3000
      });
      return;
    }

    if (product.hasTirePrice === 1) {
      product.minTireQty = Math.min.apply(Math, this.tireQuantityArray);
      product.tirePrice = this.tirePrice;
    } else {
      product.tirePrice = '';
      product.minTireQty = 0;
    }
    if (this.currentUser) {

      const params: any = {};
      params.productId = product.productId;
      params.quantity = this.quantity;
      params.productPrice = product.price;
      params.tirePrice = this.tirePrice;
      params.varientName = product.variantName;
      params.productVarientOptionId = product.variantId;
      params.selectedImage = product.Images.image;
      params.skuName = product.sku;
      params.type = 'new';

      if (product.productOption && product.productOption.length > 0) {
        const tempParams: any = {};
        tempParams.totalOptions = this.totalPrice;
        tempParams.options = product.productOption;
        if (this.optionValueArray.length > 0) {
          const array = [];
          this.optionValueArray.forEach(data => {
            if (data !== null) {
              array.push(data);
            }
          });
          tempParams.optionValueArray = array;
        }
        if (this.selectedOptions && this.selectedOptions.length > 0) {
          const array = [];
          this.selectedOptions.forEach(data => {
            if (data !== null) {
              array.push(data);
            }
          });
          product.selectedOptions = array;
          params.productOptionValueId = array;
        } else {
          params.productOptionValueId = [];
        }
        params.optionName = JSON.stringify(tempParams);
        params.optionValueName = '';
      } else {
        params.productOptionValueId = [];
      }

      this.cartBaseSandbox.doAddToCart(params);
    }
    if (product.optionRequired === 1 && this.optionValueArray.length > 0) {
      const params: any = {};
      params.id = product.productId;
      this.listSandbox.getProductDetailsMandatory(params);
    } else {
      this.products = product;
      const param: any = {};
      param.totalOptions = this.totalPrice;
      product.productCount = this.quantity;
      product.selectedImage = product.Images.image;
      product.skuName = product.sku;
      console.log(" ***** product.productType ", product);

      if (product.productType == 2) {
        product.skuName = product.price + product.Images.image;
      } else {
        product.skuName = product.skuName;
      }
      console.log("product values ");
      console.log(product);

      if (this.optionValueArray.length > 0) {
        const array = [];
        this.optionValueArray.forEach(data => {
          if (data !== null) {
            array.push(data);
          }
        });
        product._optionValueArray = array;
        param._optionValueArray = array;
      } else {
        product._optionValueArray = [];
        param._optionValueArray = [];
      }

      if (this.selectedOptions && this.selectedOptions.length > 0) {
        const array = [];
        this.selectedOptions.forEach(data => {
          if (data !== null) {
            array.push(data);
          }
        });
        product.selectedOptions = array;
      } else {
        product.selectedOptions = [];
      }
      this.controlSandbox.selectedOptions(param);
      product._totalOptions = param.totalOptions;
      if (product.Selected === true) {
        product.taxValue = this.taxValue;
        product.taxType = this.taxType;
        product.price = this.productPrice;
      }
      this.controlSandbox.addItemsToCart(product, param);
      this.emptyData();
      if (status) {
        this.router.navigate(['/checkout']);
      } else {
        //this.viewCartPopup();
      }
    }
  }

  viewCartPopup() {
    const dialogRef = this.dialog.open(CartPopupComponent, {
      panelClass: 'make-quotation',
      hasBackdrop: true,
      // position: { left: '71.5%' }
      // animation: { to: "left" },
      // position:{rowEnd: "71.5%"}


    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
      }
    });
  }

  // add product for comparison
  addToCompare(product) {
    this.selectCompare.emit(product.productId);
  }

  // clear the decorator optionValueArray value in the product detail component
  public emptyData() {
    this.emptyDecorator.emit('clear');
  }

  // emit the data from open product dialoug component
  public openProductDialog(event) {
    this.OpenProductDialog.emit(event);
  }

  // emit quantity while changing
  public changeQuantity(value) {
    this.QuantityChange.emit(value);
  }

  public getFeaturedList() {
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    params.sku = '';
    this.listSandbox.getFeaturedList(params);
  }

  public getTodayDealList() {
    const params: any = {};
    params.limit = 0;
    params.offset = 0;
    params.keyword = '';
    params.sku = '';
    this.listSandbox.getTodayDealList(params);
  }

  // unsubscribe subscribed events while destroy the page
  ngOnDestroy() {
    this.subscriptions.forEach(each => {
      each.unsubscribe();
    });
  }
}
